import Usuario from './Usuario'

class TipoRecorrente {
    constructor(
        {
            id = null,
            codigo = null,
            descricao = null,
            created_at = null,
            updated_at = null,
            deleted_at = null,
            usuario_id = null,
            usuario = {},
        } = {}
    ) {
        this.id = id;
        this.codigo = codigo;
        this.descricao = descricao;
        this.created_at = created_at;
        this.updated_at = updated_at;
        this.deleted_at = deleted_at;
        this.usuario_id = usuario_id;

        //ORM
        this.usuario = usuario ? new Usuario(usuario) : new Usuario();

    }
}

export default TipoRecorrente;